module.exports = __webpack_public_path__ + "h5/img/i_nav1.bbbdb9e7.png";